<template>
    <div>
        <slot name="title"></slot>

        <br class="mb-3"/>

        <select-as-radio-field
            v-model="hasElements"
            :field="{label: $t('finalevaluation.hasReadmissions')}"
            class="text-center mb-5"
            field-name="has-readmissions"
            yes-no
        />

        <div v-if="hasElements" class="mb-3">
            <div
                v-for="(readmission, index) in $v.elements.$each.$iter"
                :key="index"
                class="mx-3 mb-5"
            >
                <multiple-card-item
                    :title="parseInt(index)+1 + 'º ' + $t('finalevaluation.readmission')"
                    @delete="deleteElement(index)"
                >
                    <date-field
                        v-model="readmission.date.$model"
                        :field="readmissionFields.date"
                        :field-name="'readmission-date-'+ index"
                        :errors="readmission.date.$invalid ? {['readmission-date-'+ index]: $t('error.required')} : {}"
                        datetime
                    />

                    <input-field
                        v-model="readmission.reason.$model"
                        :field="readmissionFields.reason"
                        :field-name="'readmission-reason-'+ index"
                        :inline="false"
                        :placeholder="$t('textarea.placeholder')"
                        form-width="auto"
                        no-center-text
                    />
                </multiple-card-item>

            </div>

            <div class="text-center">
                <hemocir-button
                    :title="$t('finalevaluation.addReadmission')"
                    font-awesome-icon="fa-plus-circle"
                    variant="outline-gray"
                    @click="addElement"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import NavigableComponentMixin from "@/components/mixins/NavigableComponentMixin";
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import DateField from "@/components/fields/DateField";
    import InputField from "@/components/fields/InputField";
    import {cloneDeep} from "lodash";
    import {required} from "vuelidate/lib/validators";
    import MultipleCardItem from "@/components/MultipleCardItem";
    import ScrollToErrorMixin from "@/components/mixins/ScrollToErrorMixin";
    import QuestionWithMultipleElementsMixin from "@/components/mixins/QuestionWithMultipleElementsMixin";

    export default {
        name: "FinalEvaluationReadmissions",
        components: {MultipleCardItem, InputField, DateField, SelectAsRadioField},
        mixins: [NavigableComponentMixin, ScrollToErrorMixin, QuestionWithMultipleElementsMixin],
        computed: {
            ...mapState([
                'finalEvaluation',
                'finalEvaluationFields',
            ]),
            ...mapStateProperty([
                {path: 'finalEvaluation.readmissions', name: 'finalEvaluationReadmissions'},
            ]),
            readmissionFields() {
                return this.finalEvaluationFields.readmissions.child.children;
            }
        },
        created() {
            if (this.finalEvaluationReadmissions.length > 0) {
                this.hasElements = true;
                this.elements = cloneDeep(this.finalEvaluationReadmissions);
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                let isValid = !this.$v.$invalid;
                if (isValid) {
                    this.storeReadmissions();
                } else {
                    this.$nextTick(this.scrollToError);
                }
                return isValid;
            },
            back() {
                this.storeReadmissions();
            },
            storeReadmissions() {
                if (this.hasElements !== true) {
                    this.finalEvaluationReadmissions = [];
                } else {
                    this.finalEvaluationReadmissions = cloneDeep(this.elements);
                }
            },
            addElement() {
                this.elements.push({
                    date: null,
                    reason: '',
                });
            },
        },
        validations: {
            elements: {
                $each: {
                    date: {
                        required
                    },
                    reason: {},
                }
            }
        }
    };
</script>

<style scoped>

</style>